export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-480-d4ba9c630cc2adedfc9dae5edaa2eb88.png";